// TODO: Remove these. They're only used today for a psuedo-form API that needs to be replaced with a proper form library
export const PRICE_KEY = 'price';
export const MIN_BATHROOM_KEY = 'min_bathroom';
export const MAX_BATHROOM_KEY = 'max_bathroom';
export const MIN_BEDROOM_KEY = 'min_bedroom';
export const MAX_BEDROOM_KEY = 'max_bedroom';
export const MIN_STORIES_KEY = 'min_stories';
export const MAX_STORIES_KEY = 'max_stories';
export const SQUAREFEET_KEY = 'square_feet';
export const STYLE_KEY = 'style';
export const FRAME_TYPES_KEY = 'frame_types';
export const FAMILY_TYPES_KEY = 'family_types';
export const SPECIAL_FEATURES_KEY = 'special_features';
